// src/push/registerPush.js — registra el SW y suscribe al Web Push del portal.
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE || "https://apiestaciones.orionadministracion.com";

function urlBase64ToUint8Array(b64) {
  const padding = "=".repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) output[i] = raw.charCodeAt(i);
  return output;
}

export async function enableWebPush({ token, estacion } = {}) {
  if (typeof window === "undefined") return { ok: false, reason: "ssr" };
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return { ok: false, reason: "unsupported" };
  }

  if (Notification.permission === "default") {
    const p = await Notification.requestPermission();
    if (p !== "granted") return { ok: false, reason: "denied" };
  } else if (Notification.permission !== "granted") {
    return { ok: false, reason: "denied" };
  }

  const reg = await navigator.serviceWorker.register("/sw.js").catch((e) => {
    console.error("[push] SW register fail", e); return null;
  });
  if (!reg) return { ok: false, reason: "sw-register" };
  await navigator.serviceWorker.ready;

  const { data: vapid } = await axios.get(`${API_BASE}/api/push/vapid-public-key`);
  const applicationServerKey = urlBase64ToUint8Array(vapid.publicKey);

  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  }

  const payload = sub.toJSON();
  await axios.post(`${API_BASE}/api/push/subscribe`, {
    endpoint: payload.endpoint,
    keys: payload.keys,
    userAgent: navigator.userAgent,
    estacion: estacion || null,
  }, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined);

  return { ok: true, endpoint: payload.endpoint };
}

export async function disableWebPush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) {
    try { await axios.post(`${API_BASE}/api/push/unsubscribe`, { endpoint: sub.endpoint }); } catch {}
    await sub.unsubscribe();
  }
}
